import { render, staticRenderFns } from "./S2-Checkbox.vue?vue&type=template&id=7e40dbd3&scoped=true"
import script from "./S2-Checkbox.vue?vue&type=script&lang=js"
export * from "./S2-Checkbox.vue?vue&type=script&lang=js"
import style0 from "./S2-Checkbox.vue?vue&type=style&index=0&id=7e40dbd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e40dbd3",
  null
  
)

export default component.exports